require("./main.css");
var $ST3N8$reactspectrumbutton = require("@react-spectrum/button");
var $ST3N8$reactspectrumdialog = require("@react-spectrum/dialog");
var $ST3N8$spectrumiconsworkflowHelpOutline = require("@spectrum-icons/workflow/HelpOutline");
var $ST3N8$spectrumiconsworkflowInfoOutline = require("@spectrum-icons/workflow/InfoOutline");
var $ST3N8$react = require("react");
var $ST3N8$reactspectrumutils = require("@react-spectrum/utils");
var $ST3N8$reactariai18n = require("@react-aria/i18n");

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $05e6407aa891f27c$exports = {};

$parcel$export($05e6407aa891f27c$exports, "ContextualHelp", () => $05e6407aa891f27c$export$7d3cdb256c2ba320);



var $c1b48b060a7ea3d2$exports = {};

$parcel$export($c1b48b060a7ea3d2$exports, "react-spectrum-ContextualHelp-button", () => $c1b48b060a7ea3d2$export$20d9583c9f1529c1, (v) => $c1b48b060a7ea3d2$export$20d9583c9f1529c1 = v);
$parcel$export($c1b48b060a7ea3d2$exports, "react-spectrum-ContextualHelp-dialog", () => $c1b48b060a7ea3d2$export$ab2d873674d20d28, (v) => $c1b48b060a7ea3d2$export$ab2d873674d20d28 = v);
$parcel$export($c1b48b060a7ea3d2$exports, "react-spectrum-ContextualHelp-content", () => $c1b48b060a7ea3d2$export$a1f805890cf58c4, (v) => $c1b48b060a7ea3d2$export$a1f805890cf58c4 = v);
$parcel$export($c1b48b060a7ea3d2$exports, "react-spectrum-ContextualHelp-footer", () => $c1b48b060a7ea3d2$export$d901bc3fa82b87a6, (v) => $c1b48b060a7ea3d2$export$d901bc3fa82b87a6 = v);
var $c1b48b060a7ea3d2$export$20d9583c9f1529c1;
var $c1b48b060a7ea3d2$export$ab2d873674d20d28;
var $c1b48b060a7ea3d2$export$a1f805890cf58c4;
var $c1b48b060a7ea3d2$export$d901bc3fa82b87a6;
$c1b48b060a7ea3d2$export$20d9583c9f1529c1 = "react-spectrum-ContextualHelp-button_d88303";
$c1b48b060a7ea3d2$export$ab2d873674d20d28 = "react-spectrum-ContextualHelp-dialog_d88303";
$c1b48b060a7ea3d2$export$a1f805890cf58c4 = "react-spectrum-ContextualHelp-content_d88303";
$c1b48b060a7ea3d2$export$d901bc3fa82b87a6 = "react-spectrum-ContextualHelp-footer_d88303";



var $07f833820f7957d4$exports = {};
var $acb7f58c98e2cf06$exports = {};
$acb7f58c98e2cf06$exports = JSON.parse("{\"help\":\"مساعدة\",\"info\":\"معلومات\"}");


var $2bbfbfd282c7ac2e$exports = {};
$2bbfbfd282c7ac2e$exports = JSON.parse("{\"help\":\"Помощ\",\"info\":\"Информация\"}");


var $fb114849c2cd165d$exports = {};
$fb114849c2cd165d$exports = JSON.parse("{\"help\":\"Nápověda\",\"info\":\"Informace\"}");


var $d915a218ab0c9e80$exports = {};
$d915a218ab0c9e80$exports = JSON.parse("{\"help\":\"Hjælp\",\"info\":\"Oplysninger\"}");


var $b967195fa197fdf6$exports = {};
$b967195fa197fdf6$exports = JSON.parse("{\"help\":\"Hilfe\",\"info\":\"Informationen\"}");


var $2e327399cfbbb22c$exports = {};
$2e327399cfbbb22c$exports = JSON.parse("{\"help\":\"Βοήθεια\",\"info\":\"Πληροφορίες\"}");


var $76d69c9d92b7631c$exports = {};
$76d69c9d92b7631c$exports = JSON.parse("{\"info\":\"Information\",\"help\":\"Help\"}");


var $f16d20dee3bf2650$exports = {};
$f16d20dee3bf2650$exports = JSON.parse("{\"help\":\"Ayuda\",\"info\":\"Información\"}");


var $681c6c332d3324fe$exports = {};
$681c6c332d3324fe$exports = JSON.parse("{\"help\":\"Spikker\",\"info\":\"Teave\"}");


var $aaae4f968feee6a5$exports = {};
$aaae4f968feee6a5$exports = JSON.parse("{\"help\":\"Ohje\",\"info\":\"Tiedot\"}");


var $6ca7aa54fe17b013$exports = {};
$6ca7aa54fe17b013$exports = JSON.parse("{\"help\":\"Aide\",\"info\":\"Informations\"}");


var $eead079849c849a8$exports = {};
$eead079849c849a8$exports = JSON.parse("{\"help\":\"עזרה\",\"info\":\"מידע\"}");


var $c595ccd23af366f1$exports = {};
$c595ccd23af366f1$exports = JSON.parse("{\"help\":\"Pomoć\",\"info\":\"Informacije\"}");


var $13646d03ad3676f9$exports = {};
$13646d03ad3676f9$exports = JSON.parse("{\"help\":\"Súgó\",\"info\":\"Információ\"}");


var $d288177f1ed0c023$exports = {};
$d288177f1ed0c023$exports = JSON.parse("{\"help\":\"Aiuto\",\"info\":\"Informazioni\"}");


var $97fad5409bb5ac4b$exports = {};
$97fad5409bb5ac4b$exports = JSON.parse("{\"help\":\"ヘルプ\",\"info\":\"情報\"}");


var $8c367af4c98bf9ef$exports = {};
$8c367af4c98bf9ef$exports = JSON.parse("{\"help\":\"도움말\",\"info\":\"정보\"}");


var $ff404be8bf7c1541$exports = {};
$ff404be8bf7c1541$exports = JSON.parse("{\"help\":\"Žinynas\",\"info\":\"Informacija\"}");


var $8f9381b231c1b1e7$exports = {};
$8f9381b231c1b1e7$exports = JSON.parse("{\"help\":\"Palīdzība\",\"info\":\"Informācija\"}");


var $66586c79322de90c$exports = {};
$66586c79322de90c$exports = JSON.parse("{\"help\":\"Hjelp\",\"info\":\"Informasjon\"}");


var $2707c2e216fd1fb0$exports = {};
$2707c2e216fd1fb0$exports = JSON.parse("{\"help\":\"Help\",\"info\":\"Informatie\"}");


var $1b8a6c42bf8a93cf$exports = {};
$1b8a6c42bf8a93cf$exports = JSON.parse("{\"help\":\"Pomoc\",\"info\":\"Informacja\"}");


var $21519e2cdfbf2418$exports = {};
$21519e2cdfbf2418$exports = JSON.parse("{\"help\":\"Ajuda\",\"info\":\"Informações\"}");


var $af034b95fde6a053$exports = {};
$af034b95fde6a053$exports = JSON.parse("{\"help\":\"Ajuda\",\"info\":\"Informação\"}");


var $4881897691d95dcd$exports = {};
$4881897691d95dcd$exports = JSON.parse("{\"help\":\"Ajutor\",\"info\":\"Informaţii\"}");


var $697e58aab1351cb6$exports = {};
$697e58aab1351cb6$exports = JSON.parse("{\"help\":\"Справка\",\"info\":\"Информация\"}");


var $18d1df2cd1fd4664$exports = {};
$18d1df2cd1fd4664$exports = JSON.parse("{\"help\":\"Pomoc\",\"info\":\"Informácie\"}");


var $5923d5e92381fe28$exports = {};
$5923d5e92381fe28$exports = JSON.parse("{\"help\":\"Pomoč\",\"info\":\"Informacije\"}");


var $0ef592839a88ef41$exports = {};
$0ef592839a88ef41$exports = JSON.parse("{\"help\":\"Pomoć\",\"info\":\"Informacije\"}");


var $c254a7ac0f4821d7$exports = {};
$c254a7ac0f4821d7$exports = JSON.parse("{\"help\":\"Hjälp\",\"info\":\"Information\"}");


var $a520943f16b6160a$exports = {};
$a520943f16b6160a$exports = JSON.parse("{\"help\":\"Yardım\",\"info\":\"Bilgiler\"}");


var $679d794c1ece5065$exports = {};
$679d794c1ece5065$exports = JSON.parse("{\"help\":\"Довідка\",\"info\":\"Інформація\"}");


var $a531570c7a651d45$exports = {};
$a531570c7a651d45$exports = JSON.parse("{\"help\":\"帮助\",\"info\":\"信息\"}");


var $487db55c4b552587$exports = {};
$487db55c4b552587$exports = JSON.parse("{\"help\":\"說明\",\"info\":\"資訊\"}");


$07f833820f7957d4$exports = {
    "ar-AE": $acb7f58c98e2cf06$exports,
    "bg-BG": $2bbfbfd282c7ac2e$exports,
    "cs-CZ": $fb114849c2cd165d$exports,
    "da-DK": $d915a218ab0c9e80$exports,
    "de-DE": $b967195fa197fdf6$exports,
    "el-GR": $2e327399cfbbb22c$exports,
    "en-US": $76d69c9d92b7631c$exports,
    "es-ES": $f16d20dee3bf2650$exports,
    "et-EE": $681c6c332d3324fe$exports,
    "fi-FI": $aaae4f968feee6a5$exports,
    "fr-FR": $6ca7aa54fe17b013$exports,
    "he-IL": $eead079849c849a8$exports,
    "hr-HR": $c595ccd23af366f1$exports,
    "hu-HU": $13646d03ad3676f9$exports,
    "it-IT": $d288177f1ed0c023$exports,
    "ja-JP": $97fad5409bb5ac4b$exports,
    "ko-KR": $8c367af4c98bf9ef$exports,
    "lt-LT": $ff404be8bf7c1541$exports,
    "lv-LV": $8f9381b231c1b1e7$exports,
    "nb-NO": $66586c79322de90c$exports,
    "nl-NL": $2707c2e216fd1fb0$exports,
    "pl-PL": $1b8a6c42bf8a93cf$exports,
    "pt-BR": $21519e2cdfbf2418$exports,
    "pt-PT": $af034b95fde6a053$exports,
    "ro-RO": $4881897691d95dcd$exports,
    "ru-RU": $697e58aab1351cb6$exports,
    "sk-SK": $18d1df2cd1fd4664$exports,
    "sl-SI": $5923d5e92381fe28$exports,
    "sr-SP": $0ef592839a88ef41$exports,
    "sv-SE": $c254a7ac0f4821d7$exports,
    "tr-TR": $a520943f16b6160a$exports,
    "uk-UA": $679d794c1ece5065$exports,
    "zh-CN": $a531570c7a651d45$exports,
    "zh-TW": $487db55c4b552587$exports
};





function $05e6407aa891f27c$var$ContextualHelp(props, ref) {
    let { variant: variant = 'help' , placement: placement = 'bottom start' , children: children , ...otherProps } = props;
    let formatMessage = $ST3N8$reactariai18n.useMessageFormatter((/*@__PURE__*/$parcel$interopDefault($07f833820f7957d4$exports)));
    let icon = variant === 'info' ? /*#__PURE__*/ ($parcel$interopDefault($ST3N8$react)).createElement(($parcel$interopDefault($ST3N8$spectrumiconsworkflowInfoOutline)), null) : /*#__PURE__*/ ($parcel$interopDefault($ST3N8$react)).createElement(($parcel$interopDefault($ST3N8$spectrumiconsworkflowHelpOutline)), null);
    let slots = {
        content: {
            UNSAFE_className: (/*@__PURE__*/$parcel$interopDefault($c1b48b060a7ea3d2$exports))['react-spectrum-ContextualHelp-content']
        },
        footer: {
            UNSAFE_className: (/*@__PURE__*/$parcel$interopDefault($c1b48b060a7ea3d2$exports))['react-spectrum-ContextualHelp-footer']
        }
    };
    let ariaLabel = otherProps['aria-label'];
    if (!ariaLabel && !otherProps['aria-labelledby']) ariaLabel = formatMessage(variant);
    return(/*#__PURE__*/ ($parcel$interopDefault($ST3N8$react)).createElement($ST3N8$reactspectrumdialog.DialogTrigger, {
        ...otherProps,
        type: "popover",
        placement: placement,
        hideArrow: true
    }, /*#__PURE__*/ ($parcel$interopDefault($ST3N8$react)).createElement($ST3N8$reactspectrumbutton.ActionButton, {
        ...otherProps,
        ref: ref,
        UNSAFE_className: (/*@__PURE__*/$parcel$interopDefault($c1b48b060a7ea3d2$exports))['react-spectrum-ContextualHelp-button'],
        isQuiet: true,
        "aria-label": ariaLabel
    }, icon), /*#__PURE__*/ ($parcel$interopDefault($ST3N8$react)).createElement($ST3N8$reactspectrumutils.SlotProvider, {
        slots: slots
    }, /*#__PURE__*/ ($parcel$interopDefault($ST3N8$react)).createElement($ST3N8$reactspectrumdialog.Dialog, {
        UNSAFE_className: (/*@__PURE__*/$parcel$interopDefault($c1b48b060a7ea3d2$exports))['react-spectrum-ContextualHelp-dialog']
    }, children))));
}
/**
 * Contextual help shows a user extra information about the state of an adjacent component, or a total view.
 */ let $05e6407aa891f27c$export$7d3cdb256c2ba320 = /*#__PURE__*/ ($parcel$interopDefault($ST3N8$react)).forwardRef($05e6407aa891f27c$var$ContextualHelp);


$parcel$exportWildcard(module.exports, $05e6407aa891f27c$exports);


